import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fa5, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AddStaffModal from "./AddSkills";
import { getAllStaff, getSkillList } from "../../CrudOperations/GetOperation";
import AddEvent from "./AddSkills";
import AddSkills from "./AddSkills";
import { DeleteSkill_fromDataBase, DeleteStaff_fromDataBase } from "../../CrudOperations/DeleteOperation";







const ManageSkills = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Staff, setStaff] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredSkillList, setFilteredSkillList] = useState([]);
  const [SkillList, setSkillList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [currentStaffId, setCurrentStaffId] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [edit, setEdit] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await getSkillList();
      console.log(response);
      
      if (response.data.Message === "Success") {
        console.log(response);
        setSkillList(response.data.Data);
        setFilteredSkillList(response.data.Data);
      }
      else {
        toast.error(response.data.ServerMessage);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {

   



    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = SkillList.filter(
      (p) =>
        p.SkillsName.toLowerCase().includes(query)

    );
    setFilteredSkillList(filteredList);
  };

  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (Staff) {
      const response = await AddStaff({ Staff });
      if (response.data.message === "Staff saved successfully!") {
        const newStaff = { Staff, id: response.data.data.id };
        setSkillList([...SkillList, newStaff]);
        setFilteredSkillList([...filteredSkillList, newStaff]);
        setStaff("");
        toast.success("Staff added successfully!");
      } else {
        toast.error("Failed to add Staff. Please try again.");
      }
    } else {
      toast.error("Please enter a valid Staff.");
    }
  };

  const handleDeleteStaff = async (id) => {

    const response = await DeleteSkill_fromDataBase(id);

    console.log(response);
    


    // if (response.data.message === "Staff deleted successfully") {
    //   toast.success("Staff deleted successfully");
    // } else {
    //   setSkillList(previousSkillList);
    //   setFilteredSkillList(previousFilteredSkillList);
    //   toast.error("Failed to delete Staff. Please try again.");
    // }

   
  };

  // handleUpdateStaff

  const handleUpdateStaff = async (p , Type) => {


    setEdit(p);

    setIsModalOpen(true);
  };

  const handleCheckboxChange = (id, isChecked) => {
    // Set the current Staff ID and the new status based on the checkbox state
    setCurrentStaffId(id);
    setNewStatus(isChecked ? "Available" : "Not Available");
    setIsConfirmModalOpen(true); // Open the confirmation modal
  };

  const confirmChangeStatus = async () => {
    if (currentStaffId !== null) {
      // Update status in SkillList
      setSkillList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      // Update status in filteredSkillList
      setFilteredSkillList((prevList) =>
        prevList.map((item) =>
          item.id === currentStaffId ? { ...item, Status: newStatus } : item
        )
      );

      try {
        const response = await UpdateStaffStatus({
          id: currentStaffId,
          Status: newStatus,
        });
        if (response.data.message === "Staff updated successfully!") {
          toast.success(`Status updated to ${newStatus} successfully!`);
        } else {
          toast.error("Error updating status.");
        }
      } catch (error) {
        toast.error("Error updating status.");
      } finally {
        setIsConfirmModalOpen(false); // Close the confirmation modal
        setCurrentStaffId(null); // Reset the ID
      }
    }
  };

  const handleAddStaffformClick = () => {
    setEdit(null); // Reset the edit state
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEdit(null); // Reset the edit state
    setIsModalOpen(false);
  };

  const handleSubmit = async() => {

    const response = await getSkillList();
      console.log(response);
      
      if (response.data.Message === "Success") {
        setSkillList(response.data.Data);
        setFilteredSkillList(response.data.Data);
      }

      setEdit(null); // Reset the edit state

    setIsModalOpen(false); // Close the modal after adding
    toast.success("Skill added or Updated successfully!");
   

  };

  const handleUpdate = (newStaff) => {
    console.log("Updated Staff:", newStaff);
    console.log("Editing Staff ID:", edit.id);
    console.log("Staff List:", SkillList);

    setSkillList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff, // Keep existing properties
              ...newStaff, // Merge properties from newStaff
            }
          : prevStaff
      )
    );

    setFilteredSkillList((prev) =>
      prev.map((prevStaff) =>
        prevStaff.id === edit.id
          ? {
              ...prevStaff,
              ...newStaff,
            }
          : prevStaff
      )
    );

    setEdit(null);
    closeModal(); // Close the modal after updating
  };


  const handleFilterChange = (e) => {
    const selectedStatus = e.target.value;

    if (!selectedStatus) {
      setFilteredSkillList(SkillList);
      return;
    }

    const filteredList = SkillList.filter(
      (item) => item.Status === selectedStatus
    );
    setFilteredSkillList(filteredList);
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Manage Skills
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />

        <div className="flex items-center gap-4">
          <button
            onClick={handleAddStaffformClick}
            className="bg-blue-600 text-white px-6 py-2 rounded-md flex items-center gap-2 transition-transform duration-200 hover:bg-blue-700 hover:scale-105 shadow-md shadow-blue-500 hover:shadow-lg"
          >
            <FontAwesomeIcon icon={faPlus} />
            Add Skill
          </button>
        </div>
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {[
                "S.No",
                "Skill Name",
                "Status",
                "Edit",
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
          {console.log(filteredSkillList)
          }
            {filteredSkillList.length > 0 ? (
              filteredSkillList.map((p,index) => (
                <tr
                  key={p.SkillId}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                     <td className="py-3 px-4 text-center">{index+1}</td>
                  <td className="py-3 px-4 text-center">{p.SkillName || "null"}</td>
                  <td className="py-3 px-4 text-center">{p.Status === 0 ? "InActive" : "Active"}</td>
                  <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleUpdateStaff(p , "edit")}
                      className="text-blue-500 transition-colors duration-200 hover:text-blue-700"
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </button>
                  </td>

                  {/* <td className="py-3 px-4 text-center">
                    <button
                      onClick={() => handleDeleteStaff(p.SkillsId)}
                      className="text-red-500 transition-colors duration-200 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td> */}



                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add Staff Modal */}
      {isModalOpen && (
        <AddSkills
          closeModal={closeModal}
          onSubmit={handleSubmit}
          Staff={edit}
          onUpdate={handleUpdate}
        />
      )}

    </div>
  );
};

export default ManageSkills;
